export enum FixedSwapState {
  Live = 101,
  Claimed = 102,
  Completed = 103,
  Canceled = 104,
}
